import axios from 'axios'
import { get, noop } from 'lodash'
import postalCodes from 'postal-codes-js'
import qs from 'qs'
import React from 'react'

export type TAddressItem = {
  name1?: string
  name2?: string
  name3?: string
  street?: string
  streetNumber?: string
  streetNumberAddition?: string
  zip?: string
  country?: string
  city?: string
  companyNumber?: string
  branche?: string
  representation?: string
  lonlat?: number[]
  ref1?: string
  ref2?: string
  ref3?: string
  reference?: string
  id?: string
}

export const mustBeValidCountryZip =
  (prefix: string) =>
  (
    value: string,
    allValues: {
      [key: string]: string
    },
  ): string | boolean | undefined => {
    const country = prefix
      ? get(allValues, `${prefix}.country`)
      : get(allValues, 'country')
    if (!country || !value || country === 'IE') return undefined
    if (postalCodes.validate(`${country.toLowerCase()}`, value) != true)
      return postalCodes.validate(`${country.toLowerCase()}`, value)
  }

export type TSuggestionItem = {
  id: string
  label: string
  street: string
  streetNumber: string
  zip: string
  country: string
  city: string
  lat: number
  lon: number
}

type TSuggestionsContext = {
  suggestions: TSuggestionItem[]
  address: any
  onRefresh: () => void
}
export type TLonLat = { lon: number; lat: number }

export const SuggestionsContext = React.createContext<TSuggestionsContext>({
  suggestions: [],
  address: {},
  onRefresh: noop,
})

const STAGING_DOMAIN = 'https://dispo.staging.1st-scan.net'

const DOMAIN = String(get(global, 'URL_DISPO')).includes('localhost')
  ? 'https://dispo.staging.1st-scan.net'
  : get(global, 'URL_DISPO') || STAGING_DOMAIN

const API_KEY = 'mapzen-adx7mSv'

const defaultQuery = {
  api_key: API_KEY,
}

export const getSuggestionsAsync = async (
  address: TAddressItem,
): Promise<TSuggestionItem[]> => {
  const fields = {
    address: `${get(address, 'street')} ${get(address, 'streetNumber')}`,
    locality: get(address, 'city'),
    postalcode: get(address, 'zip'),
    country: String(get(address, 'country')).toLowerCase(),
  }
  const query = {
    ...defaultQuery,
    sources: 'osm',
    ...fields,
  }
  const queryString = qs.stringify(query, { allowDots: true })
  const url = `${DOMAIN}/geocoding/v1/search/structured?${queryString}`
  const response = await axios({
    method: 'get',
    url,
    withCredentials: false,
    validateStatus: (status) => status === 200,
    headers: { 'Accept-Language': i18n?.language ?? 'de' },
  })

  const items: TSuggestionItem[] = get(response, 'data.features', []).map(
    (feature) => {
      const {
        properties: {
          housenumber,
          street,
          postalcode,
          locality,
          localadmin,

          country_a,
          id,
          label,
        },
        geometry: { coordinates },
      } = feature

      return {
        id,
        label,
        street: street,
        streetNumber: housenumber,
        zip: postalcode,
        country: country_a,
        city: localadmin || locality,
        lat: get(coordinates, 1),
        lon: get(coordinates, 0),
      }
    },
  )
  return items
}
